import { render, staticRenderFns } from "./inquiry-price-plans-cloud-rent.vue?vue&type=template&id=797a08c9&scoped=true&"
import script from "./inquiry-price-plans-cloud-rent.vue?vue&type=script&lang=js&"
export * from "./inquiry-price-plans-cloud-rent.vue?vue&type=script&lang=js&"
import style0 from "./inquiry-price-plans-cloud-rent.vue?vue&type=style&index=0&id=797a08c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797a08c9",
  null
  
)

export default component.exports